(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  pinForCartDrawer() {
    if (this.cartDrawerPinned) return;
    this.cartDrawerPinned = true;
    this._cartDrawerHadSticky = this.header.classList.contains('shopify-section-header-sticky');
    this._cartDrawerHadHidden = this.header.classList.contains('shopify-section-header-hidden');
    this._cartDrawerHadScrolled = this.header.classList.contains('scrolled-past-header');
    this._cartDrawerHadAnimate = this.header.classList.contains('animate');
    this._cartDrawerPreventReveal = this.preventReveal;
    this.preventReveal = true;
    this.header.classList.add('shopify-section-header-sticky', 'cart-drawer-pinned');
    this.header.classList.remove('shopify-section-header-hidden', 'animate');
    this.setHeaderHeight();
  }
  syncHeaderHeightForCartFly() {
    if (this.header) this.setHeaderHeight();
  }
  unpinForCartDrawer() {
    if (!this.cartDrawerPinned) return;
    this.cartDrawerPinned = false;
    this.preventReveal = this._cartDrawerPreventReveal;
    this.header.classList.remove('cart-drawer-pinned');
  }
  onScroll() {
    if (this.cartDrawerPinned) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kl-upcoming"] && !Shopify.designMode) return;
  try {
    
(() => {
  const utcDay = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const [y,m,d] = value.split('-').map(Number);
    const date = new Date(Date.UTC(y,m-1,d));
    return date.toISOString().slice(0,10) === value ? date.getTime() : null;
  };
  const todayInTurkey = () => {
    const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Istanbul',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const get = (name) => parts.find(p => p.type === name).value;
    return utcDay(`${get('year')}-${get('month')}-${get('day')}`);
  };
  const daysUntil = (date,today) => { const day = utcDay(date); return day === null ? null : Math.round((day-today)/86400000); };
  const foldLine = (line) => {
    const enc = new TextEncoder(); let length = 0, result = '';
    for (const ch of line) { const n=enc.encode(ch).length; if(length+n>73){ result+='\r\n ';length=1;} result+=ch;length+=n; }
    return result;
  };
  const escapeIcs = (s) => String(s).replace(/\\/g,'\\\\').replace(/\r?\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
  const makeCalendar = (game,description) => {
    const time=utcDay(game.date); if(time===null)return null;
    const start=game.date.replaceAll('-',''), end=new Date(time+86400000).toISOString().slice(0,10).replaceAll('-','');
    return ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Kontorland//Oyun Takvimi//TR','CALSCALE:GREGORIAN','BEGIN:VEVENT',`UID:${game.key}-release@kontorland.com.tr`,`DTSTAMP:${new Date().toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'')}`,`DTSTART;VALUE=DATE:${start}`,`DTEND;VALUE=DATE:${end}`,`SUMMARY:${escapeIcs(game.title)}`,`DESCRIPTION:${escapeIcs(description)}`,`URL:${game.source}`,'TRANSP:TRANSPARENT','END:VEVENT','END:VCALENDAR'].map(foldLine).join('\r\n')+'\r\n';
  };
  function init(root) {
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const cards=[...root.querySelectorAll('[data-game-key]')].sort((a,b)=>(a.dataset.gameDate||`${a.dataset.gameYear||'9999'}-99-99`).localeCompare(b.dataset.gameDate||`${b.dataset.gameYear||'9999'}-99-99`));
    cards.forEach(card=>root.querySelector('[data-game-grid]').append(card));
    const gameSelect=root.querySelector('[data-game-select]'), platformSelect=root.querySelector('[data-platform-select]');
    const platformFilter=root.querySelector('[data-filter-platform]'),monthFilter=root.querySelector('[data-filter-month]'),search=root.querySelector('[data-filter-search]');
    const gameFromCard=(card)=>({key:card.dataset.gameKey,title:card.dataset.gameTitle,platforms:card.dataset.gamePlatforms.split('|'),date:card.dataset.gameDate,year:card.dataset.gameYear||card.dataset.gameDate.slice(0,4),source:card.dataset.gameSource});
    const games=cards.map(gameFromCard);
    const initialPlatforms=[...new Set(games.flatMap(g=>g.platforms))].sort();
    const updatePlatforms=()=>{
      const selected=gameSelect.selectedOptions[0], platforms=selected?.dataset.platforms?.split('|') || initialPlatforms;
      const previous=platformSelect.value;
      platformSelect.replaceChildren(new Option(root.dataset.platformPlaceholder,''),...platforms.map(p=>new Option(p,p)));
      if(platforms.includes(previous))platformSelect.value=previous;
      else if(platforms.length===1)platformSelect.value=platforms[0];
    };
    gameSelect.addEventListener('change',updatePlatforms);
    const requestSelect=root.querySelector('[data-request-select]'), consentCopy=root.querySelector('[data-consent-copy]'), consentInput=root.querySelector('.kl-up__consent input'), followConsent=consentCopy.textContent;
    requestSelect.addEventListener('change',()=>{const cancel=requestSelect.selectedIndex===1;consentCopy.textContent=cancel?root.dataset.cancelConsent:followConsent;consentInput.value=cancel?'Seçilen oyun için bildirim iptal talebi onaylandı.':'Seçilen oyun için bildirim talebi ve e-posta iletişim izni onaylandı.';consentInput.checked=false;});
    root.querySelectorAll('[data-notify]').forEach(button=>button.addEventListener('click',()=>{
      const option=[...gameSelect.options].find(o=>o.dataset.key===button.dataset.notify);
      if(option){gameSelect.value=option.value;updatePlatforms();requestSelect.selectedIndex=0;consentCopy.textContent=followConsent;consentInput.value='Seçilen oyun için bildirim talebi ve e-posta iletişim izni onaylandı.';consentInput.checked=false;gameSelect.focus({preventScroll:true});}
    }));
    const platforms=[...new Set(games.flatMap(g=>g.platforms))].sort();
    platforms.forEach(p=>platformFilter.add(new Option(p,p)));
    const years=[...new Set(games.map(g=>g.year).filter(Boolean))].sort();
    years.forEach(y=>monthFilter.add(new Option(`${y} ${root.dataset.yearSuffix}`,`year:${y}`)));
    if(years.includes(root.dataset.focusYear))monthFilter.value=`year:${root.dataset.focusYear}`;
    const months=[...new Set(games.filter(g=>utcDay(g.date)!==null).map(g=>g.date.slice(0,7)))].sort();
    months.forEach(m=>monthFilter.add(new Option(new Intl.DateTimeFormat(document.documentElement.lang||'tr',{month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(m+'-01T00:00:00Z')),m)));
    if(games.some(g=>utcDay(g.date)===null))monthFilter.add(new Option(root.dataset.unknownPeriod,'unknown'));
    const matchesPeriod=(g,value)=>!value||(value==='unknown'?utcDay(g.date)===null:value.startsWith('year:')?g.year===value.slice(5):g.date.startsWith(value));
    const filter=()=>{
      const query=search.value.trim().toLocaleLowerCase('tr');let count=0;
      cards.forEach((card,i)=>{const g=games[i];const remaining=daysUntil(g.date,todayInTurkey());const show=(remaining===null||remaining>=0)&&(!platformFilter.value||g.platforms.includes(platformFilter.value))&&matchesPeriod(g,monthFilter.value)&&(!query||g.title.toLocaleLowerCase('tr').includes(query));card.hidden=!show;if(show)count++;});
      root.querySelector('[data-result-count]').textContent=`${count} ${root.dataset.countSuffix}`;
      root.querySelector('[data-empty]').hidden=count!==0;
    };
    platformFilter.addEventListener('change',filter);monthFilter.addEventListener('change',filter);search.addEventListener('input',filter);
    root.querySelector('[data-reset]').addEventListener('click',()=>{platformFilter.value='';monthFilter.value='';search.value='';filter();search.focus();});
    cards.forEach((card,i)=>{const button=card.querySelector('[data-calendar]');if(button&&utcDay(games[i].date)!==null){button.hidden=false;button.addEventListener('click',()=>{
      const content=makeCalendar(games[i],root.dataset.calendarDescription);const url=URL.createObjectURL(new Blob([content],{type:'text/calendar;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download=`kontorland-${games[i].key}.ics`;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
    });}});
    const updateCountdowns=()=>{
      const today=todayInTurkey();const hero=root.querySelector('[data-hero-date]');if(hero){const remaining=daysUntil(hero.dataset.heroDate,today);hero.hidden=remaining!==null&&remaining<0;}root.querySelectorAll('[data-countdown]').forEach(el=>{const n=daysUntil(el.dataset.countdown,today);el.textContent=n===null?root.dataset.unknown:n>0?`${n} ${root.dataset.days}`:n===0?root.dataset.today:root.dataset.released;});
    };
    updateCountdowns();filter();root.querySelector('[data-filters]').hidden=false;
    const onVisible=()=>{if(!document.hidden){updateCountdowns();filter();}};document.addEventListener('visibilitychange',onVisible);
    const interval=setInterval(()=>{if(!root.isConnected){clearInterval(interval);document.removeEventListener('visibilitychange',onVisible);return;}if(!document.hidden){updateCountdowns();filter();}},60000);
  }
  document.querySelectorAll('[data-kl-upcoming]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-kl-upcoming]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if (!customElements.get('kl-facet-search')) {
  customElements.define('kl-facet-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('input', event => {
        event.stopPropagation();
        const needle = event.target.value.trim().toLocaleLowerCase(document.documentElement.lang || 'tr');
        const panel = this.parentElement;
        let count = 0;
        panel.querySelectorAll('li.facets__item, li.mobile-facets__item').forEach(row => {
          const value = row.querySelector('input[type="checkbox"]');
          if (!value) return;
          const visible = !needle || value.value.toLocaleLowerCase(document.documentElement.lang || 'tr').includes(needle);
          row.classList.toggle('kl-filter-hidden', !visible);
          if (visible) count++;
        });
        this.querySelector('[role="status"]').hidden = count > 0;
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter') event.preventDefault();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
